<template>
    <div class="container">
        <ul>
            
            <li class="list-item " v-for="(info,index) in infos " v-if="info.device.type=='TAG'||info.device.type=='BLUETOOTH'" :key="index" data-type="0">
                <div v-if="info.device.type=='TAG'" @touchstart.capture="touchStart" @touchend.capture="touchEnd">
                    <div class="list-box device_box" @click="choosePet(info)">
                        <div class="device_code">
                            <img :src="'../../../static/img/'+info.device.type +'.jpg'" alt="">
                            <span>{{info.device.deviceCode}}</span>
                        </div>
                        <div class="bind_pet">
                            <img :src="info.petDto?info.petDto.portrait:imgadd" align="absmiddle" alt="">
                            <span>{{info.petDto?info.petDto.name:$t('device.noBindPet')}}</span>
                        </div>
                    </div>
                    <div class="opration delete" v-if="!info.petDto" @click="deleteItem(info.device.deviceCode)" :data-index="index">{{$t('device.delDevice')}}</div>
                    <div class="opration unbind" v-if="info.petDto" @click="unbindItem(info.device.deviceCode)" :data-index="index">{{$t('device.unbind')}}</div>
                </div>

                <div v-if="info.device.type=='BLUETOOTH'">
                    <div class="list-box device_box">
                        <div class="device_code">
                            <img :src="'../../../static/img/'+info.device.type +'.jpg'" alt="">
                            <span>{{info.device.deviceCode}}</span>
                        </div>
                        <div class="bind_pet">
                            <img :src="info.petDto?info.petDto.portrait:imgadd" align="absmiddle" alt="">
                            <span>{{info.petDto?info.petDto.name:$t('device.noBindPet')}}</span>
                        </div>
                    </div>
                </div>
            </li>
        </ul>
        <div class="warn">
            <img src="../image/attention.png" alt="">
            <span>{{$t('device.hint')}}</span>
        </div>
    </div>
</template>

<script>
import { unbindPet } from "../ClientServerApi/index.js";
import { unbindDevice } from "../deviceApi/index.js";

import Qs from "qs";
export default {
    inject: ["reload"],
    name: "slider",
    props: ["infos"],
    data() {
        return {
            startX: 0,
            endX: 0,
            imgadd: require("../image/add-s.png"),
            isShow: false
        };
    },
    created(){
        // console.log('1111:',this.infos)
     },
    methods: {
        
        //跳转
        skip() {
            if (this.checkSlide()) {
                this.restSlide();
            } else {
                alert("You click the slide!");
            }
        },
        //滑动开始
        touchStart(e) {
            this.startX = e.touches[0].clientX;
            // console.log(this.startX);
        },
        //滑动结束
        touchEnd(e) {
            let parentElement = e.currentTarget.parentElement;
            this.endX = e.changedTouches[0].clientX;

            if (
                parentElement.dataset.type == 0 &&
                this.startX - this.endX > 30
            ) {
                this.restSlide();
                parentElement.dataset.type = 1;
            }

            if (
                parentElement.dataset.type == 1 &&
                this.startX - this.endX < -30
            ) {
                this.restSlide();
                parentElement.dataset.type = 0;
            }

            this.startX = 0;
            this.endX = 0;
        },
        //判断当前是否有滑块处于滑动状态
        checkSlide() {
            let listItems = document.querySelectorAll(".list-item");

            for (let i = 0; i < listItems.length; i++) {
                if (listItems[i].dataset.type == 1) {
                    return true;
                }
            }
            return false;
        },
        //一次只能滑动一个
        restSlide() {
            let listItems = document.querySelectorAll(".list-item");
            for (let i = 0; i < listItems.length; i++) {
                listItems[i].dataset.type = 0;
            }
        },
        //删除设备
        deleteItem(code) {
            this.$confirm(this.$t('device.isDelete'), this.$t('device.deleteDevice'), {
                confirmButtonText: this.$t('mapinfo.sure'),
                cancelButtonText: this.$t('prompt.cancel'),
                type: "warning"
            })
                .then(() => {
                    let params = Qs.stringify({ code: code });
                    unbindDevice(params)
                        .then(res => {
                            console.log(res);
                            if (res.data.header.status == 1000) {
                                this.reload();
                            }
                        })
                        .catch(err => {});
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: this.$t('prompt.ycanceldelete')
                    });
                });
        },
        //解绑宠物
        unbindItem(code) {
            this.$confirm(this.$t('prompt.slider'), this.$t('prompt.yslider'), {
                confirmButtonText: this.$t('prompt.sure'),
                cancelButtonText: this.$t('prompt.cancel'),
                type: "warning"
            })
                .then(() => {
                    let params = Qs.stringify({ deviceCode: code });
                    unbindPet(params)
                        .then(res => {
                            console.log(res);
                            if (res.data.header.status == 81003) {
                                this.$message({
                                    message: this.$t('prompt.finding'),
                                    type: "warning"
                                });
                            } else if (res.data.header.status == 1000) {
                                this.reload();
                            } else if (res.data.header.status == 80002) {
                                this.$message.error(this.$t('prompt.nodevice'));
                            }
                        })
                        .catch(error => {});
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: this.$t('prompt.notcancel')
                    });
                });
        },
        //向父组件传递打开choosePet面板信息
        choosePet(info) {
            // console.log("info111:",info)
            let thisDeviceCode = info.device.deviceCode;
            let hasPetDto;
            if(info.petDto==null){
               hasPetDto="0"
            }else{
                hasPetDto="1"
            }
            console.log(hasPetDto)
            this.$emit("listen-is-show", {
                show: true,
                deviceCode: thisDeviceCode,
               
            });
        }
    }
};
</script>
<style scoped>
.container {
    width: 100%;
    overflow-x: hidden;
}
.container .warn {
    margin-top: 20px;
    text-align: center;
    /* height: 40px;
    line-height: 40px; */
}
.container .warn img {
    height: 15px;
    width: 15px;
    vertical-align: middle;
}
.container .warn span {
    font-size: 14px;
    color: #b3b3b3;
}
.page-title {
    text-align: center;
    font-size: 17px;
    padding: 10px 15px;
    position: relative;
}
.page-title:after {
    content: " ";
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
    height: 1px;
    border-bottom: 1px solid #ccc;
    color: #ccc;
    -webkit-transform-origin: 0 100%;
    transform-origin: 0 100%;
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
    z-index: 2;
}
.list-item {
    position: relative;
    height: 4.6rem;
    -webkit-transition: all 0.2s;
    transition: all 0.2s;
}
.list-item[data-type="0"] {
    transform: translate3d(0, 0, 0);
}
.list-item[data-type="1"] {
    transform: translate3d(-4rem, 0, 0);
}
.list-item:after {
    content: " ";
    position: absolute;
    left: 0.2rem;
    bottom: 0;
    right: 0;
    height: 1px;
    border-bottom: 1px solid #ccc;
    color: #ccc;
    -webkit-transform-origin: 0 100%;
    transform-origin: 0 100%;
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
    z-index: 2;
}
.list-box {
    padding: 0.2rem;
    background: #fff;
    display: flex;
    align-items: center;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    justify-content: flex-end;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    font-size: 0;
}
.list-item .list-img {
    display: block;
    width: 1rem;
    height: 1rem;
}
.list-item .list-content {
    padding: 0.1rem 0 0.1rem 0.2rem;
    position: relative;
    flex: 1;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    overflow: hidden;
}
.list-item .title {
    display: block;
    color: #333;
    overflow: hidden;
    font-size: 15px;
    font-weight: bold;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.list-item .tips {
    display: block;
    overflow: hidden;
    font-size: 12px;
    color: #999;
    line-height: 20px;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.list-item .time {
    display: block;
    font-size: 12px;
    position: absolute;
    right: 0;
    top: 0.1rem;
    color: #666;
}
.list-item .unbind {
    background: #9d9d9d;
}
.list-item .delete {
    background: #ff4949;
}
.list-item .opration {
    width: 4rem;
    height: 4.6rem;
    font-size: 0.85rem;
    color: #fff;
    text-align: center;
    line-height: 4.6rem;
    position: absolute;
    top: 0;
    right: -4rem;
}
/*样式*/
.device_content {
    margin-top: 25px;
    padding: 10px;
}
.device_content .device_title,
.device_box {
    display: flex;
    flex-wrap: nowrap;
    flex-direction: row;
    font-size: 0.85rem;
    padding: 5px 0;
    border-bottom: 1px solid #eee;
}
.device_content .device_code,
.device_box .device_code {
    flex: 6;
    color: #3f3f3f;
}
.device_content .bind_pet,
.device_box .bind_pet {
    flex: 18;
    padding-left: 10px;
}
.device_box {
    padding: 10px 0;
}
.device_box .bind_pet {
    border-left: 1px solid #eee;
    line-height: 65px;
}
.device_code img {
    width: 1.5rem;
    display: block;
    margin: 0 auto;
}
.device_code span {
    display: block;
    margin-top: 5px;
    font-size: 0.5rem;
    text-align: center;
}
.bind_pet img {
    width: 3rem;
    height: 3rem;
    border-radius: 50%;
    vertical-align: middle;
}
.bind_pet span {
    padding-left: 10px;
    color: #808080;
    font-size: 0.75rem;
    line-height: 65px;
}
</style>


// WEBPACK FOOTER //
// src/components/slider.vue